import * as React from "react";
import { Context } from "./_context";
export const IdeaIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M15 22H9v-2h6v2ZM12 1a8 8 0 0 1 4 14.928V17.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-1.572A8 8 0 0 1 12 1Zm0 2a6 6 0 0 0-2.571 11.423 1 1 0 0 1 .571.903V16.5h4v-1.174a1 1 0 0 1 .571-.903A6 6 0 0 0 12 3Z", fill: "currentColor" }));
  return iconset[size];
};
IdeaIcon.iconId = "u8OYeO";
